import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  deleteMSGroupAdmins,
  deleteMSSchedule,
  deleteMSScheduleAdmins,
  deleteMSWeekends,
  getMSCalendarDay,
  getMSCalendarMonth,
  getMSGroupAdmins,
  getMSGroupAdminsInfinite,
  getMSScheduleAdmins,
  getMSScheduleDetail,
  getMSSchedules,
  getMSAvailableSlots,
  getMSPriorityAgent,
  getMSScheduleStatuses,
  getMSScheduleTags,
  getMSWeekdays,
  getMSWeekends,
  patchMSScheduleTags,
  postMSScheduleTags,
  postMSGroupAdmins,
  postMSScheduleAdmins,
  patchMSScheduleNote,
  patchMSScheduleStatus,
  postMSReportWhatsappDraft,
  postMSReportWhatsappSend,
  postMSSchedules,
  postMSWeekdays,
  postMSWeekends,
  putMSGroupAdmins,
  putMSScheduleAdmins,
  putMSSchedules,
  setMSCalendarAvailable,
  setMSCalendarAvailableAll,
} from "apis/meetingSchedule";
import { useAntdMessage } from "hooks/useAntdMessage";

export function useMSScheduleAdmins(options = {}, payload = {}) {
  return useQuery({
    queryKey: ["MSScheduleAdmins", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSScheduleAdmins(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSScheduleAdmins() {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postMSScheduleAdmins,
    // onSuccess: (data, variables) => {
    //   queryClient.setQueryData(["MSScheduleAdmins"], (oldData) => {
    //     console.log(data, variables, oldData);
    //     if (!isEmpty(oldData.data)) {
    //       return {
    //         ...oldData,
    //         data: [...oldData.data, { ...data.data.data }],
    //       };
    //     }
    //     return {
    //       ...oldData,
    //       data: [{ ...data.data.data }],
    //     };
    //   });
    // },
    // onError: (error) => {
    //   console.log(error);
    // },
  });
}

export function usePutMSScheduleAdmins() {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putMSScheduleAdmins,
    // onSuccess: (data) => {
    //   queryClient.setQueryData(["MSScheduleAdmins"], (oldData) => {
    //     return {
    //       ...oldData,
    //       data: oldData.data.map((item) => {
    //         if (item.id === data.data.data.id) {
    //           return data.data.data;
    //         }
    //         return item;
    //       }),
    //     };
    //   });
    // },
  });
}

export function useDeleteMSScheduleAdmins() {
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteMSScheduleAdmins,
    // onSuccess: (data) => {
    //   queryClient.setQueryData(["MSScheduleAdmins"], (oldData) => {
    //     return {
    //       ...oldData,
    //       data: oldData.data.filter((item) => item.id !== data.data.data.id),
    //     };
    //   });
    // },
  });
}

// admin groups

export function useMSGroupAdmins(payload = {}, options = {}) {
  return useQuery({
    queryKey: ["MSGroupAdmins", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSGroupAdmins(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSGroupAdmins() {
  return useMutation({
    mutationFn: postMSGroupAdmins,
  });
}

export function usePutMSGroupAdmins() {
  return useMutation({
    mutationFn: putMSGroupAdmins,
  });
}

export function useDeleteMSGroupAdmins() {
  return useMutation({
    mutationFn: deleteMSGroupAdmins,
  });
}

// weekends

export function useMSWeekends(options = {}, payload = {}) {
  return useQuery({
    queryKey: ["MSWeekends", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSWeekends(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSWeekends() {
  return useMutation({
    mutationFn: postMSWeekends,
  });
}

export function useDeleteMSWeekends() {
  return useMutation({
    mutationFn: deleteMSWeekends,
  });
}

// weekdays
export function useMSWeekdays(options = {}) {
  return useQuery({
    queryKey: ["MSWeekdays"],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSWeekdays();
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSWeekdays() {
  return useMutation({
    mutationFn: postMSWeekdays,
  });
}

// meeting schedule calendar
export function useGetMSCalendarMonth(payload, options = {}) {
  return useQuery({
    queryKey: ["MSCalendarMonth", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSCalendarMonth(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useGetMSCalendarDay(payload = {}, options = {}) {
  return useQuery({
    queryKey: ["MSCalendarDay", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSCalendarDay(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useSetMSCalendarAvailable() {
  return useMutation({
    mutationFn: (payload) => setMSCalendarAvailable(payload),
    // onSuccess: (
    //   data
    //   //  payload
    // ) => {
    //   if (data.data.success) {
    //     // const date = dayjs(payload.date, "YYYY-MM-DD")
    //     //   .startOf("month")
    //     //   .format("YYYY-MM-DD");
    //     // butuh fix update kueri key MSCalendarMonth, payloadnya bukan date doang
    //     // queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth"] });
    //     // queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth", date] });
    //   }
    // },
  });
}

export function useSetMSCalendarAvailableAll() {
  return useMutation({
    mutationFn: setMSCalendarAvailableAll,
  });
}

export function useMSScheduleDetail(id, options = {}) {
  return useQuery({
    queryKey: ["MSScheduleDetail", id],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSScheduleDetail(id);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useDeleteMSSchedule() {
  return useMutation({
    mutationFn: (id) => deleteMSSchedule(id),
  });
}

export function useGetMSSchedules(payload = {}, options = {}) {
  return useQuery({
    queryKey: ["MSSchedules", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSSchedules(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    // placeholderData: keepPreviousData,
    ...options,
  });
}

export const useInfiniteGroupAdmin = (payload, options = {}) => {
  const { message } = useAntdMessage();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ["infinite/group-admin", payload],
    queryFn: async ({ pageParam }) => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSGroupAdminsInfinite({
          page: pageParam,
          per_page: 200,
          ...payload,
        });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage) {
        return undefined;
      }
      return lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined;
    },
    onError: (error) =>
      message.error(
        error?.message ||
          error?.data?.message ||
          "Failed to load data from server!"
      ),
    keepPreviousData: true,
    ...options,
  });
};

export const useInfiniteAdminMeeting = (payload, options = {}) => {
  const { message } = useAntdMessage();
  return useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ["infinite/admin-meeting", payload],
    queryFn: async ({ pageParam }) => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSScheduleAdmins({
          page: pageParam,
          per_page: 200,
          ...payload,
        });
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    getNextPageParam: (lastPage) => {
      if (!lastPage) {
        return undefined;
      }
      return lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined;
    },
    onError: (error) =>
      message.error(
        error?.message ||
          error?.data?.message ||
          "Failed to load data from server!"
      ),
    keepPreviousData: true,
    ...options,
  });
};

export function useMSGroupAdminsAll(payload = {}, options = {}) {
  return useQuery({
    queryKey: ["MSGroupAdmins", payload],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSGroupAdmins(payload);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSSchedules() {
  return useMutation({
    mutationFn: postMSSchedules,
  });
}

export function usePutMSSchedules() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putMSSchedules,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["MSScheduleDetail", variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth"] });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarDay"] });
      queryClient.invalidateQueries({ queryKey: ["MSSchedules"] });
    },
  });
}

export function usePatchMSScheduleNote() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchMSScheduleNote,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["MSScheduleDetail", variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth"] });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarDay"] });
      queryClient.invalidateQueries({ queryKey: ["MSSchedules"] });
    },
  });
}

export function useMSScheduleStatuses(locale = "id-ID", options = {}) {
  return useQuery({
    queryKey: ["MSScheduleStatuses", locale],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSScheduleStatuses({ locale });
        response = Array.isArray(data) ? data : [];
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePatchMSScheduleStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchMSScheduleStatus,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["MSScheduleDetail", variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth"] });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarDay"] });
      queryClient.invalidateQueries({ queryKey: ["MSSchedules"] });
    },
  });
}

// laporan meeting → WhatsApp ke customer
export function usePostMSReportWhatsappDraft() {
  return useMutation({ mutationFn: postMSReportWhatsappDraft });
}

export function usePostMSReportWhatsappSend() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postMSReportWhatsappSend,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["MSScheduleDetail", variables.id],
      });
    },
  });
}

// meeting schedule availability (auto select agent)
export function useMSAvailableSlots() {
  return useMutation({
    mutationFn: getMSAvailableSlots,
  });
}

export function useMSPriorityAgent() {
  return useMutation({
    mutationFn: getMSPriorityAgent,
  });
}

// meeting schedule tags (master)
export function useMSScheduleTags(options = {}) {
  return useQuery({
    queryKey: ["MSScheduleTags"],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getMSScheduleTags();
        response = Array.isArray(data) ? data : data?.data ?? [];
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function usePostMSScheduleTags() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postMSScheduleTags,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["MSScheduleTags"] });
    },
  });
}

export function usePatchMSScheduleTags() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: patchMSScheduleTags,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["MSScheduleDetail", variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarMonth"] });
      queryClient.invalidateQueries({ queryKey: ["MSCalendarDay"] });
      queryClient.invalidateQueries({ queryKey: ["MSSchedules"] });
    },
  });
}
